import React, { useContext, useState } from 'react'
import { Button, Form, Modal, Spinner } from 'react-bootstrap'
import { ThemeContext } from '../../../../auth';
import axios from '../../../../api/axios';
import Swal from 'sweetalert2';
import Icon from '@mdi/react';
import { mdiEye, mdiEyeOff } from '@mdi/js';
import Select from 'react-select';

import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
    password: Yup.string().min(8, 'Password setidaknya harus memiliki 8 karakter').required('Password is required'),
});

function ModalAddUser({
    showAddUser,
    setShowAddUser,
    retrieveUser,
    tokenUser,
    listDivisi
}) {

    const { theme } = useContext(ThemeContext);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [userName, setUserName] = useState('');
    const [selectedDivisi, setSelectedDivisi] = useState(null);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [disabled, setDisabled] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [error, setError] = useState('');

    const handleClose = () => {
        setShowAddUser(false);
        setFirstName('');
        setLastName('');
        setUserName('');
        setSelectedDivisi(null);
        setEmail('');
        setPassword('');
    };

    const divisiOptions = listDivisi.map(divisi => ({
        value: divisi.id,
        label: divisi.name,
    }));

    const handleSelectDivisi = selectedOption => {
        setSelectedDivisi(selectedOption);
    };

    const [passwordShown, setPasswordShown] = useState(false);
    const togglePassword = () => {
        setPasswordShown(!passwordShown);
    };

    const handleSubmitUser = async (event) => {
        event.preventDefault();

        setError('');

        try {

            await validationSchema.validate({ password });

            setIsSubmitting(true);
            const data = {
                first_name: firstName,
                last_name: lastName,
                username: userName,
                groups: selectedDivisi?.value,
                email: email,
                password: password,
            };
            setDisabled(true);

            try {
                const response = await axios.post(`/account/users/`, data, {
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                        withCredentials: true,
                        Authorization: `Token ` + tokenUser,
                    },
                });

                handleClose();
                Swal.fire({
                    icon: 'success',
                    title: 'Berhasil menambahkan user',
                    showConfirmButton: true,
                });
                retrieveUser();
                setIsSubmitting(false);
                setDisabled(false);

            } catch (err) {
                console.error(err);
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Terjadi kesalahan saat menambahkan user',
                });
                setIsSubmitting(false);
                setDisabled(false);
            }
        } catch (err) {
            setError(err.message);
        }
    };


    const formStyles = {
        label: {
            fontFamily: 'Poppins-Medium',
            color: theme === 'light' ? '#FFFFFF' : '#222222',
        },
        input: {
            color: theme === 'light' ? '#FFFFFF' : '#222222',
            fontFamily: 'Poppins-Regular',
            minHeight: '50px',
            borderColor: '#ced4da',
        },
    };

    const selectStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: '50px',
            border: state.isFocused ? '1px solid #80bdff' : '1px solid #ced4da',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
            boxShadow: state.isFocused ? '0 0 0 0.3rem rgba(0, 123, 255, 0.25)' : null,
            '&:hover': {
                borderColor: '#80bdff',
            },
            fontFamily: 'Poppins-Regular',
        }),
        singleValue: (provided, state) => ({
            ...provided,
            color: theme === 'light' ? (state.isFocused ? 'red' : 'white') : (state.isFocused ? 'red' : '#222'),
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : '#333',
            background: state.isSelected ? '#007bff' : '#fff',
            fontFamily: 'Poppins-Regular',
        }),
        input: (provided) => ({
            ...provided,
            color: theme === 'light' ? '#FFFFFF' : '#222',
            fontFamily: 'Poppins-Regular',
        }),
        menuList: (provided) => ({
            ...provided,
            padding: '0', // Remove extra padding
            maxHeight: '150px', // Reduce max height of dropdown
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            padding: '4px',
        }),
    };

    return (
        <Modal
            show={showAddUser}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            centered
            data-bs-theme={theme === 'light' ? 'dark' : ''}
        >
            <Modal.Header closeButton >
                <Modal.Title style={{ fontFamily: 'Poppins-Medium', color: theme === 'light' ? '#FFFFFF' : '#222222' }}>
                    Tambah User
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmitUser}>
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='first_name'>Nama Depan*</Form.Label>
                        <Form.Control
                            id='first_name'
                            type="text"
                            onChange={(e) => setFirstName(e.target.value)}
                            value={firstName}
                            required
                            placeholder="Masukkan nama depan"
                            style={formStyles.input}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='last_name'>Nama Belakang*</Form.Label>
                        <Form.Control
                            id='last_name'
                            type="text"
                            onChange={(e) => setLastName(e.target.value)}
                            value={lastName}
                            required
                            placeholder="Masukkan nama belakang"
                            style={formStyles.input}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='division'>Divisi*</Form.Label>
                        <Select
                            id='division'
                            options={divisiOptions}
                            required
                            value={selectedDivisi}
                            onChange={handleSelectDivisi}
                            styles={selectStyles}
                            placeholder='Select...'
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='email'>Email*</Form.Label>
                        <Form.Control
                            id='email'
                            type="email"
                            onChange={(e) => setEmail(e.target.value)}
                            value={email}
                            required
                            placeholder="Masukkan email"
                            style={formStyles.input}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='username'>Username*</Form.Label>
                        <Form.Control
                            id='username'
                            type="text"
                            onChange={(e) => setUserName(e.target.value)}
                            value={userName}
                            required
                            placeholder="Masukkan username"
                            style={formStyles.input}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='password'>Password*</Form.Label>
                        <Form.Control
                            id='password'
                            type={passwordShown ? "text" : "password"}
                            onChange={(e) => setPassword(e.target.value)}
                            value={password}
                            required
                            placeholder="Masukkan password"
                            style={formStyles.input}
                            isInvalid={!!error}
                        />
                        {error && (
                            <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
                        )}
                        <p className='mt-2'
                            onClick={togglePassword}
                            style={{ fontFamily: 'Poppins-Regular', cursor: 'pointer', maxWidth: '170px', color: theme === 'light' ? '#FFFFFF' : '#222' }}
                        >
                            {passwordShown ? "Hide" : "Show"} password <span >{passwordShown ? <Icon path={mdiEyeOff} size={0.8} /> : <Icon path={mdiEye} size={0.8} />} </span></p>
                    </Form.Group>
                    <div className="d-grid gap-2 mt-4">
                        {isSubmitting ? (
                            <Button
                                id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                variant='btn'
                                disabled
                            >
                                <Spinner
                                    animation="border"
                                    size='sm'
                                />
                            </Button>
                        ) : (
                            <Button
                                type="submit"
                                id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                variant='btn'
                                disabled={disabled || !firstName || !lastName || !email || !selectedDivisi || !userName || !password}
                            >
                                Simpan
                            </Button>
                        )}
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    )
}

export default ModalAddUser
